export default {
  loading: state => state.loading,
  user: state => state.user
}
